import {
    CSSProperties,
    forwardRef
} from "react";
import { Separator } from "../Separator";

const ChromeTabsWrapper = forwardRef<HTMLDivElement, { className?: string, darkMode?: boolean}>((props, ref) => {
    const classList = ['chrome-tabs'];
    if (props.darkMode) {
      classList.push('chrome-tabs-dark-theme');
    }
    if (props.className) {
      classList.push(props.className);
    }
    return (
      <>
      <div
        ref={ref}
        className={classList.join(' ')}
        style={{ "--tab-content-margin": "9px" } as CSSProperties}
      >
        <div className="chrome-tabs-content"></div>
      </div>
      <Separator/>
      </>
    );
});

export {ChromeTabsWrapper}